import { createReducer } from 'redux-act';
import { setTourActive } from 'modules/actions';

export interface ITourReducer {
	is_tour_active: boolean
}

const defaultState = {
	is_tour_active: false
}

export const tour = createReducer<ITourReducer>({}, defaultState)
	.on(setTourActive, (state, payload) => ({
		...state,
		is_tour_active: payload
	}))